export function ticketHasMessage(html: string): boolean {
  const document = new DOMParser().parseFromString(html || '', 'text/html');
  document.querySelectorAll('script, style').forEach(node => node.remove());
  return !!(document.body.textContent || '').replace(/[\u200b\u200c\ufeff]/g, '').trim();
}

export function ticketFormErrors(title: string, category: string, message: string): { [key: string]: string } {
  const errors: { [key: string]: string } = {};
  if (!(title || '').trim()) errors.title = 'عنوان تیکت الزامی است.';
  else if (title.trim().length > 50) errors.title = 'عنوان تیکت حداکثر ۵۰ کاراکتر است.';
  if (!Number.isInteger(Number(category)) || Number(category) <= 0) errors.category = 'موضوع تیکت را انتخاب کنید.';
  if (!ticketHasMessage(message)) errors.message = 'متن تیکت الزامی است.';
  return errors;
}

export function ticketRequestError(error: any): string {
  return typeof error?.error?.message === 'string' ? error.error.message : 'عملیات تیکت انجام نشد؛ دوباره تلاش کنید.';
}
